(function () {

  if (window.__algolia_reviews_loaded) return;
  window.__algolia_reviews_loaded = true;

  console.log("[Algolia Reviews] numeric + stars active");

  const REVIEW_DATA = {
    "trazol-rna-reagent": {rating: 5.0, count: 9},
"hipure-total-rna-mini-kit": {rating: 5.0, count: 4},
"12-ml-culture-and-test-tubes":  {rating:  5.0,  count: 1},
"2-phanta-max-master-mix":  {rating:  5.0,  count: 1},
"80-well-microtube-racks":  {rating:  5.0,  count: 1},
"96-well-pcr-plates-clear-low-profile-non-skirted":  {rating:  5.0,  count: 1},
"analytical-balance-fa-s":  {rating:  5.0,  count: 1},
"bacterial-genomic-dna-kit":  {rating:  5.0,  count: 1},
"bionesium-pipette-controller":  {rating:  5.0,  count: 1},
"bionesium-pipette-pipettor":  {rating:  5.0,  count: 1},
"cell-culture-dish":  {rating:  5.0,  count: 1},
"clonexpress-ii-one-step-cloning-kit":  {rating:  5.0,  count: 1},
"copy-of-bionesium-r-single-channel-pipette-pipettor":  {rating:  5.0,  count: 1},
"copy-of-dyena-view-gel-stain":  {rating:  5.0,  count: 4},
"dyena-view-gel-stain-hb-1":  {rating:  5.0,  count: 1},
"easypure-r-genomic-dna-kit":  {rating:  5.0,  count: 1},
"easypure-rna-kit":  {rating:  4.5,  count: 2},
"easytaq-r-dna-polymerase":  {rating:  5.0,  count: 2},
"eclifemto-ecl-chemiluminescence-kit":  {rating:  5.0,  count: 1},
"free-standing-microcentrifuge-tubes-with-screw-caps-0-5-1-5-and-2-ml":  {rating:  5.0,  count: 1},
"gb-amp-2-x-pcr-master-mix-with-loading-dye":  {rating:  5.0,  count: 1},
"gb-amp-influor-green-qpcr-mix-1":  {rating:  5.0,  count: 6},
"gb-amp-taq-dna-polymerase":  {rating:  5.0,  count: 2},
"gb-clean-plasmid-miniprep-kit":  {rating:  5.0,  count: 5},
"gb-lab-mini-vortex-mixer":  {rating:  5.0,  count: 1},
"gb-ruler-100bp-dna-ladder-plus":  {rating:  3.0,  count: 1},
"gb-script-iii-1-st-strand-cdna-synthesis-kit-gdna-wiper":  {rating:  5.0,  count: 1},
"gb-script-ts-1st-strand-cdna-synthesis-kit-gdna-wiper":  {rating:  5.0,  count: 1},
"gel-pcr-2in1-kit-gel-pure-dna-kit":  {rating:  5.0,  count: 1},
"hipure-ffpe-dna-kit":  {rating:  5.0,  count: 1},
"hipure-total-rna-plus-kit":  {rating:  5.0,  count: 1},
"hipure-universal-rna-kit":  {rating:  5.0,  count: 1},
"hiscript-iii-rt-supermix-for-qpcr-gdna-wiper":  {rating:  5.0,  count: 1},
"human-creatine-kinase-mm-isoenzymeck-mm-elisa-kit":  {rating:  5.0,  count: 1},
"integrated-horizontal-electrophoresis-system-electrophoresis-tank-blue-light-transilluminator":  {rating:  5.0,  count: 1},
"le-agarose":  {rating:  5.0,  count: 1},
"low-retention-pre-filled-filter-pipette-boxes":  {rating:  5.0,  count: 1},
"lyse-n-amptm-mouse-genotyping-kit":  {rating:  5.0,  count: 2},
"mdamalondialdehyde-elisa-kit":  {rating:  5.0,  count: 1},
"mini-centrifuge-for-pcr-1-5-2-ml-tubes-and-pcr-strip-tubes":  {rating:  5.0,  count: 1},
"mycoblue-mycoplasma-detector":  {rating:  5.0,  count: 1},
"mycolor-one-step-mycoplasma-detector":  {rating:  5.0,  count: 1},
"on-column-dnase-digestion-kit":  {rating:  5.0,  count: 2},
"peasy-r-uni-seamless-cloning-and-assembly-kit":  {rating:  5.0,  count: 1},
"perfectstart-r-universal-green-qpcr-supermix":  {rating:  5.0,  count: 2},
"plasmid-dna-extraction-maxi-kit-favorfilter-endotoxinfree-ion-exchange":  {rating:  5.0,  count: 2},
"plasmid-dna-extraction-midi-kit-50prep-favorfilter-ion-exchange":  {rating:  4.0,  count: 1},
"pristine-br-broad-range-tri-color-pre-stained-protein-ladder-10-250-kda":  {rating:  4.0,  count: 1},
"pristine-pre-stained-protein-ladders-8-195-kda":  {rating:  5.0,  count: 2},
"ribo-off-rrna-depletion-kit-human-mouse-rat":  {rating:  5.0,  count: 1},
"sealing-films-for-multi-well-plates":  {rating:  5.0,  count: 1},
"sharps-container-biohazardous-waste-disposal-8l":  {rating:  4.0,  count: 1},
"ssdna-20-single-stranded-dna-ladders-1":  {rating:  5.0,  count: 1},
"trans5alpha-chemically-competent-cell":  {rating:  5.0,  count: 1},
"transintro-mrna-transfection-reagent":  {rating:  5.0,  count: 1},
"transintro-r-el-transfection-reagent":  {rating:  5.0,  count: 1},
"transscript-r-all-in-one-first-strand-cdna-synthesis-supermix-for-qpcr-one-step-gdna-removal":  {rating:  5.0,  count: 1},
"transscript-r-ii-green-one-step-qrt-pcr-supermix":  {rating:  5.0,  count: 1},
"2x-gb-amp™-pacer™-hp™-master-mix": { rating: 5.0, count: 6}
  };

  function buildStars(rating) {
    const full = Math.floor(rating);
    let stars = "";
    for (let i = 0; i < 5; i++) {
      stars += (i < full) ? "★" : "☆";
    }
    return stars;
  }

  function injectReviews() {

    document.querySelectorAll(".ais-hit, .aa-Item").forEach(card => {

      if (card.dataset.reviewInjected) return;

      let handle = card.getAttribute("data-handle");

      if (!handle) {
        const link = card.querySelector('a[href*="/products/"]');
        const href = link?.getAttribute("href") || "";
        const match = href.match(/\/products\/([^/?]+)/);
        handle = match ? match[1] : null;
      }

      if (!handle) return;

      const review = REVIEW_DATA[handle];
      if (!review) return;

      if (!review.count || review.count <= 0) return;

      const title =
        card.querySelector(".ais-hit--title") ||
        card.querySelector(".aa-ItemContentTitle") ||
        card.querySelector(".aa-ItemTitle");

      if (!title) return;

      const el = document.createElement("div");

      el.style.marginTop = "6px";
      el.style.fontSize = "13px";
      el.style.color = "#666";
el.style.display = "flex";
el.style.alignItems = "center";
el.style.justifyContent = "flex-end";
el.style.width = "100%";
el.style.gap = "6px";

      const ratingText = review.rating.toFixed(1);

      el.innerHTML =
        '<span style="color:#f5a623;">' + buildStars(review.rating) + '</span>' +
        '<span>' + ratingText + '</span>' +
        '<span>(' + review.count + ' reviews)</span>';

      title.insertAdjacentElement("afterend", el);

      card.dataset.reviewInjected = "true";
    });
  }

  setInterval(injectReviews, 800);

})();